

// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { connectFirestoreEmulator, getFirestore } from 'firebase/firestore';
import { getAuth , signInWithPopup, GoogleAuthProvider, connectAuthEmulator  } from "firebase/auth";
import { connectStorageEmulator, getStorage } from "firebase/storage";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: process.env.REACT_APP_API_KEY,
  authDomain: process.env.REACT_APP_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_PROJECT_ID,
  storageBucket: process.env.REACT_APP_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_ID,
  measurementId: process.env.REACT_APP_MEASUREMENT_ID
};

const app = initializeApp(firebaseConfig);
const firestore = getFirestore(app);
const storage = getStorage(app);
// // Firestore
// if (window.location.hostname === "localhost") {
//   console.log('firestore is running on local');
//   connectFirestoreEmulator(firestore, 'localhost', 8039);
// }
// if (window.location.hostname === "localhost") {
//   connectStorageEmulator(storage, 'localhost', 9198);
// }
// if (window.location.hostname === "localhost") {
//   connectAuthEmulator(getAuth(app), "http://localhost:9039");
// }

const provider = new GoogleAuthProvider();
provider.setCustomParameters({   
  prompt : "select_account "
});
provider.addScope("https://www.googleapis.com/auth/adwords");
export const auth = getAuth(app);

export const signInWithGooglePopup = () => signInWithPopup(auth, provider);
// Initialize Firebase
export default app;
export { firestore , storage};
